//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'Advertisement',
  props: {
    adUnitEn: {
      type: String,
      required: true
    },
    adUnitNl: {
      type: String,
      required: true
    },
    size: {
      type: Array,
      required: true
    },
    sizeMapping: {
      type: Array,
      default: () => []
    },
    isBanner: {
      type: Boolean,
      default: false
    },
    isBackgroundGrey: {
      type: Boolean,
      default: false
    },
    isFromHome: {
      type: Boolean,
      default: false
    },
    isEmpty: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      interval: null
    }
  },
  computed: {
    language() {
      return this.$store.get('language/locale') || 'en'
    },
    adUnit() {
      return this.language === 'en' ? this.adUnitEn : this.adUnitNl
    },
    currentBreakPoint() {
      return this.$store.get('app/currentBreakPoint') || 'md'
    }
  },
  beforeDestroy() {
    clearInterval(this.interval)
  },
  mounted() {
    this.interval = setInterval(() => {
      if (this.$refs.gptAds && this.$refs.gptAds.$el) this.onClassChange(this.$refs.gptAds.$el.classList.value)
    }, 1000)
  },
  methods: {
    onClassChange(classList) {
      if (classList.includes('is-empty')) {
        if (this.isBanner) {
          this.$refs.gptAds.$el.parentNode.parentNode.parentNode.classList.add('is-hidden')
        } else {
          this.$refs.gptAds.$el.parentNode.parentNode.parentNode.parentNode.classList.add('is-hidden')
        }
        this.$emit('update:isEmpty', true)
        clearInterval(this.interval)
      } else if (classList.includes('has-ads')) {
        this.$emit('updateSize')
        clearInterval(this.interval)
      }
    }
  }
}
